import { render, staticRenderFns } from "./ChainsStatistics.vue?vue&type=template&id=b3ef3066&scoped=true&"
import script from "./ChainsStatistics.vue?vue&type=script&lang=ts&"
export * from "./ChainsStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./ChainsStatistics.vue?vue&type=style&index=0&id=b3ef3066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ef3066",
  null
  
)

export default component.exports